<template>
  <div>
    <vggrid ref="xGrid" :random="Math.floor(Math.random() * 999999)"  class="vggrid" :list="list" flexname=""
          :cols="cols"
          :showfooter="false"
          :showPage="false" :resizable="true"
          @cellClick="cellClick">
    </vggrid>
    <el-dialog :close-on-click-modal="false"  @close="onClose" title="履约得分表" :visible.sync="performanceScoreShowDialogVisible" width="800px"
               :modal-append-to-body="false">
      <span>供应商： {{ currentPsu.comfullname }}</span>
      <el-divider></el-divider>
      <div style="display: flex;justify-content: center;">
        <el-row :gutter="20">
          <el-form :model="currentPsu" ref="ruleForm" :rules="rules" label-width="0">
            <el-col :span="6">
              <div style="display: flex;flex-direction: column;align-items: center;">
                <span style="font-weight: bold; font-size: 16px;margin-bottom: 12px;">履约基础分</span>
                <el-form-item prop="psuperformancebasicas">
                  <el-input v-model="currentPsu.psuperformancebasicas" 
                            :disabled="+project.projectstatus >= 30 "
                            @blur="scoreFixed($event, 'psuperformancebasicas')"
                            >
                  </el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="4" >
              <div style="display: flex;justify-content: center;flex-direction: column;">
                <div style="font-weight: bold;font-size: 32px;text-align: center;width: 100%;">
                  {{ currentPsu.operate ? '+' : '-' }}
                </div>
                
                <el-form-item prop="operate" style="text-align: center;">
                  <el-switch v-model="currentPsu.operate" class="tool" active-text="+" inactive-text="-" :disabled="+project.projectstatus >= 30 "></el-switch>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="6">
              <div style="display: flex;flex-direction: column;align-items: center;">
                <span style="font-weight: bold; font-size: 16px;margin-bottom: 12px;">履约加减法</span>
                <el-form-item prop="psuperformanceadjustas">
                  <el-input @blur="scoreFixed($event, 'psuperformanceadjustas')" v-model="currentPsu.psuperformanceadjustas" :disabled="+project.projectstatus >= 30 "></el-input>
                </el-form-item>
              </div>
            </el-col>
            <el-col :span="3" style="margin-top: 24px;">
              <span style="font-weight: bold;font-size: 32px;text-align: center;width: 100%;">=</span>
            </el-col>
            <el-col :span="4">
              <div style="display: flex;flex-direction: column;align-items: center;">
                <span style="font-weight: bold; font-size: 16px;margin-bottom: 12px;">履约得分</span>
                <span style="font-weight: bold; font-size: 22px;">{{ +project.projectstatus >= 30  ? currentPsu.psuperformanceas :  score}}</span>
              </div>
            </el-col>
          </el-form>
      </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
         <el-button @click="performanceScoreShowDialogVisible = false">取消</el-button>
         <el-button type="primary" @click="onClick" v-show="+project.projectstatus < 30 ">保存</el-button>
      </span>
    </el-dialog>
  </div>
  
</template>
<script>
const validatePsuperformancebasicas = (rule, value, callback) => {
    if (value === '') {
      callback(new Error('请输入履约基础分'))
    }
    if (isNaN(+value)) {
      callback(new Error('请输入数值'))
    }
    callback()
  }
  const validatePsuperformanceadjustas = (rule, value, callback) => {
    if (value === '') {
      callback(new Error('请输入履约加减分'))
    }
    if (isNaN(+value)) {
      callback(new Error('请输入数值'))
    }
    callback()
  }
import vggrid from '../common/vggrid'
import request from "@/utils/request";
import utils from '../../assets/js/utils'
export default {
  props: {
      projectid: Number,
      activeName: {},
  },
  data () {
    return {
      rules: {
          psuperformancebasicas: [
            { validator: validatePsuperformancebasicas, trigger: 'blur' }
          ],
          psuperformanceadjustas: [
            { validator: validatePsuperformanceadjustas, trigger: 'blur' }
          ]
      },
      project:{},
      cols: [
          {type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 50},
          {field: 'comfullname', fieldtype: 'C', title: '供应商', calculExpr: '', addNewRowFlg: false},
          {field: 'psuperformancebasicas', fieldtype: 'C', title: '履约基础分', calculExpr: '', addNewRowFlg: false},
          {field: 'psuperformanceadjustas', fieldtype: 'C', title: '履约加减分', calculExpr: '', addNewRowFlg: false},
          {field: 'psuperformanceas', fieldtype: 'C', title: '履约总分', calculExpr: '', addNewRowFlg: false},
      ],
      list: [],
      currentPsu: {},
      prsList: [],
      performanceScoreShowDialogVisible: false
    }
  },
  async created () {
    this.initCols()
    await this.getModel()
  },
  async mounted () {
    // this.initCols()
    await this.getModel()
  },
  methods: {
    cellClick () {},
    async onClick () {
      this.$refs['ruleForm'].validate(async (valid) => {
        if (valid) {
            if (+this.currentPsu.psuperformanceas > +this.project.projectperformancescore) {
              this.$message.error(`履约分不能大于当前项目的履约绝对值:${+this.project.projectperformancescore}!当前履约分:${+this.currentPsu.psuperformanceas}`)
              return false
            }
            if (this.currentPsu.psuperformanceas < 0) {
              this.$message.error('履约分不能为负值')
              return false
            }
            // const score = +this.currentPsu.diffScore + +this.currentPsu.psuperformanceas
            // if ( isNaN(score) || score > 100) {
            //   this.$message.error(`价格分加履约分得分不能超过100,当前得分${score}`)
            //   return false
            // }
            let pgs = await request({
              method: 'get',
              url: '/xmgl/pg/getPsrByCommid',
              params: {
                pscomid: this.currentPsu.psucomid,
                psprojectid: this.project.projectid
              }
            })
            pgs = pgs.length > 0 ? pgs[0] : {}
            let { issuccess, msg } = await request({
              method: 'post',
              url: '/cwgl/psuproject/savePsuperformanceas',
              data: {
                psuperformancebasicas: this.currentPsu.psuperformancebasicas,
                psuperformanceadjustas: this.currentPsu.psuperformanceadjustas,
                psuperformanceas: this.currentPsu.psuperformanceas,
                psuperformanceoperate: +this.currentPsu.operate,
                psuas: +this.currentPsu.psuperformanceas + (isNaN(+pgs.psppriceasexchange) ? 0 : +pgs.psppriceasexchange) + (isNaN(+pgs.pscommercialasexchange) ? 0 : +pgs.pscommercialasexchange),
                psuid: this.currentPsu.psuid,
                psperformanceas: +this.currentPsu.psuperformanceas,
                psuprojectid: this.project.projectid
              }
            })
          if (+issuccess === 1) {
            this.$message.success('保存成功')
          } else {
            this.$message.error(msg)
          }
          
          this.performanceScoreShowDialogVisible = false
          await this.getModel()
        } else {
          console.log('error submit!!');
          return false;
        }
      })
    },
    onPerformanceScoreShowClick (row) {
      this.currentPsu = JSON.parse(JSON.stringify(row))
      this.performanceScoreShowDialogVisible = true
      this.$set(this.currentPsu, 'operate', row.psuperformanceoperate === null ? true : Boolean(+row.psuperformanceoperate))
      this.$refs['ruleForm'] && this.$refs['ruleForm'].resetFields()
    },
    async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.projectid}
        })
        this.project = res
        this.list = await request({
          url: '/xmgl/project/getPsuListFromPriceMark',
          method: "get",
          params: {
            projectid: this.projectid,
            projectisqcheck: this.project.projectisqcheck
          }
        })
        let prsList = await request({
          method: 'get',
          url: 'expert/getpsrecList',
          params:{psprojectid: this.projectid}
        })
        this.prsList = prsList
    },
    initCols() {
        this.cols.push({
          title: '', width: 160, showOverflow: true,
          slots: {
            default: 'default',
            default: ({row}) => {
              return [<div><vxe-button type="primary" onClick={this.onPerformanceScoreShowClick.bind(this,row)}>得分明细</vxe-button></div>]
            }
          }
        })
    },
    scoreFixed (el, name) {
        let inputVal = el.target.value || ''
        this.currentPsu[name] = Number(inputVal).toFixed(2)
      },
    async onClose () {
      this.currentPsu = {}
    }
  },
  computed: {
    score () {
        this.currentPsu.psuperformanceas = this.currentPsu.operate ? +this.currentPsu.psuperformancebasicas + +this.currentPsu.psuperformanceadjustas : +this.currentPsu.psuperformancebasicas - +this.currentPsu.psuperformanceadjustas
        if (this.currentPsu.psuperformanceas) {
          this.currentPsu.psuperformanceas = this.currentPsu.psuperformanceas.toFixed(2)
          return utils.comdify(this.currentPsu.psuperformanceas + '')
        }
        else  return utils.comdify(0 + '')
      }
  },
  watch:{
      activeName () {
        if(this.activeName === 'lvf') {
            this.getModel()
        }
      }

    },
  components: { vggrid }
}
</script>
